import {useCallback, useEffect, useState} from 'react';
import axiosInstance from "../../../../../axiosInstance";

const useGetUserInfo = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(() => {
    setLoading(true)
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = "/api/account"
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance.get(fullUrl)
        .then((res) => {
          setData(res.data);
          resolve(res.data);
        })
        .catch(reject)
        .finally(() => {
          setLoading(false)
        });
    })
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  return {data, loading, getData};
};

export default useGetUserInfo;
